import { MODEL_ID } from 'Pods/ThreeDStudio/Store/constants'

const PROVIDER_KEY = 'tencent_hunyuan'

/**
 * Inverse of parseTencentRetextureProData. Builds an openedModel-shaped payload
 * from the current textureSettings so the just-submitted run can be reopened
 * without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTencentRetextureProData
 */
export const buildTencentRetextureProFromState = (state, id) => {
  const { textureSettings } = state
  const {
    prompt,
    enablePbr,
    inputImage,
    inputImageUrl,
  } = textureSettings || {}
  const geometryOnly = false

  const inputAssets = inputImage != null
    ? [{
        assetType: 'image',
        source: 'user_upload',
        assetId: inputImage,
        fileUrl: inputImageUrl,
      }]
    : undefined

  return {
    id,
    providerKey: PROVIDER_KEY,
    providerModelId: MODEL_ID.TENCENT_RETEXTURE_PRO,
    prompt,
    enablePbr,
    geometryOnly,
    inputAssets,
    providerRunAttributes: {},
  }
}
